import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { ButtonSize } from 'packages/kakapo-ui-kit/types/Button';

import QuillText from '../editors/QuillText';
import Modal, { ModalBackground, ModalContent } from '../modals/Modal';
import ModalHeader from '../modals/ModalHeader';
import PlainButton from '../buttons/PlainButton';
import { SubmitButton } from '../buttons/PrimaryButton';

export default function CycleMomentInstructionModal(props: {
	title: string;
	instruction?: graphql.LocalizedAttributedString;
	buttonTitle: string;
	onCancel: () => void;
	onStart: () => void;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader onCancel={() => props.onCancel()}>{props.title}</ModalHeader>
				<ModalContent>
					<QuillText quill={localize(props.instruction ?? [])?.text} />

					<Flex flexDirection="row" justifyContent="space-between" mt={4} alignItems="center">
						<Box>
							<PlainButton
								size={ButtonSize.Medium}
								type="button"
								fullWidth
								onClick={() => props.onCancel()}
							>
								{t('evaluations.request.modal.cancel')}
							</PlainButton>
						</Box>

						<Box>
							<SubmitButton
								size={ButtonSize.Medium}
								type="submit"
								value={props.buttonTitle}
								fullWidth
								onClick={props.onStart}
							/>
						</Box>
					</Flex>
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
